import React from "react";
import Image from "next/image";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";

const features = [
  {
    title: "Live Sessions",
    icon: "/main-website/camera.svg",
    description:
      "We provide live classes to our students. You can attend the classes from anywhere in the world.",
  },
  {
    title: "Gamified Approach",
    icon: "/main-website/gamified.svg",
    description:
      "We save all the session recordings in case you miss a class or want to rewatch a class.",
  },
  {
    title: "Win Prizes upto ₹10,000",
    icon: "/main-website/prize.svg",
    description:
      "We have a community of 1000+ students who are learning together.",
  },
];

const certificateBenefits = [
  "Official And Verified",
  "Easily Shareable",
  "Enhances Your Credibility",
  "Placement Support",
];

export default function Overview({ bootcamp }: { bootcamp: any }) {
  return (
    <div className="space-y-6 p-2 bg-[#EEEBE6]">
      <div
        className="prose max-w-full prose-p:text-justify prose-h2:text-2xl prose-h2:font-semibold prose-p:text-[#1A1A1ACC] prose-p:text-lg prose-p:font-medium prose-li:font-medium prose-li:text-lg prose-li:text-[#1A1A1ACC] prose-ul:list-disc"
        dangerouslySetInnerHTML={{
          __html: bootcamp.longDescription,
        }}
      />

      {features.map((feature) => (
        <Card key={feature.title} className="border-0">
          <CardHeader className="flex items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-lg font-semibold flex items-center w-full justify-between">
              {feature.title}
              <div className="flex items-center justify-center">
                <Image src={feature.icon} width={40} height={40} alt="icon" />
              </div>
            </CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-muted-foreground">
              {feature.description}
            </p>
          </CardContent>
        </Card>
      ))}

      <section>
        <h4 className="text-2xl font-semibold mb-4">
          Receive a Certificate on completion
        </h4>
        <div className="flex gap-8 items-center flex-col md:flex-row md:gap-4 lg:gap-8">
          <Image
            src={bootcamp.certificateImage || "/bootcamps/certificate.png"}
            alt="certificate"
            className="object-contain"
            width={175}
            height={250}
          />

          <div className="space-y-2 text-xl">
            {certificateBenefits.map((benefit) => (
              <div
                key={benefit}
                className="flex items-center gap-2 md:text-sm md:gap-1"
              >
                <Image
                  src="/main-website/Vector.svg"
                  width={16}
                  height={16}
                  alt="decorative icon"
                />
                {benefit}
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
